"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function IOThermometer(props) {
    let { width, height, size } = props;
    if (size !== undefined) {
        width = size;
        height = size;
    }
    if (width === undefined && height === undefined) {
        width = 16;
        height = 16;
    }
    return (react_1.default.createElement("svg", { className: "glx--icon glx-io-icon", width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
        react_1.default.createElement("path", { d: "M320 287.18V81c0-35.12-27.89-64.42-63-64.95a64.08 64.08 0 00-65 64v207.13a8 8 0 01-3.18 6.37A113.48 113.48 0 00144 384a112 112 0 00224 0 113.48 113.48 0 00-44.82-90.45 8 8 0 01-3.18-6.37zM254.07 432a48 48 0 01-22-89.54 16 16 0 008-13.84V112.45c0-8.61 6.62-16 15.23-16.43A16 16 0 01272 112v216.58a16.18 16.18 0 008.15 13.94A48 48 0 01254.07 432z" })));
}
exports.default = IOThermometer;
